import { makeStyles } from '@griffel/react';

import type { GriffelClassNames } from '../../../../util/classNames';
import { tokens } from '../../../../util/theme/fluent9';

export const useClassNames: () => GriffelClassNames<'footer'> = makeStyles({
  footer: {
    width: '100%',
    backgroundColor: tokens.colorNeutralForegroundInverted,
    display: 'flex',
    justifyContent: 'center',
    zIndex: 1,
  },
});
